<template>
  <div class="operation-main">
    <div class="operation-head">
      <el-input
        placeholder="请输入内容"
        size="mini"
        v-model="searchData">
        <el-button slot="append" icon="el-icon-search" size="mini" @click="search" style="background: #fff;"></el-button>
      </el-input>
    </div>
    <div class="operation-content">
      <div class="operation-left">
        <div style="display: flex;align-items:center;">
          <img class="operation-img" style="margin-right:8px;" src="../../assets/org.png">
        </div>
        <span class="operation-title">使用中的组织</span>
      </div>
      <div>
        <img @click="mutiEdit" class="operation-img" style="margin-right:16px;" src="../../assets/mutichange.png" />
        <img @click="add"  class="operation-img" src="../../assets/add.png" />
      </div>
    </div>
  </div>

</template>
<script>
export default {
  components: {
  },
  data () {
    return {
      searchData: ''
    }
  },
  methods: {
    search () {
      this.$emit('search', this.searchData)
    },
    mutiEdit () {
      this.$emit('mutiEdit')
    },
    add () {
      this.$emit('add')
    }
  }
}
</script>
<style scoped>
.operation-main {
  display: flex;
  flex-direction: column;
}
.operation-head {
  margin-bottom: 8px;
  margin-left: 26px;
}
.operation-content {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 8px;
}
.operation-img {
  width: 20px;
  height: 20px;
}
.operation-title {
  font-family: 'PingFangSC-Regular', 'PingFang SC';
  font-weight: 400;
  font-style: normal;
  font-size: 16px;
  color: #6699FF;
}
.operation-left {
  margin-left: 20px;
  display: flex;
}
</style>
